import { fetcher } from "helpers/fetcher";

import { TArchiveTicketReq, TArchiveTicketRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const archiveTicket = async (payload: TArchiveTicketReq) => {
  return await fetcher<TArchiveTicketRes, TArchiveTicketReq["data"]>(
    ENDPOINT.MANAGEMENT.ARCHIVE_TICKET,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.ARCHIVE_TICKET.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: payload.urlData,
    }
  );
};

export const mutationArchiveTicket = async (payload: TArchiveTicketReq) => {
  return (await archiveTicket(payload)).data;
};

mutationArchiveTicket._key = (payload: TArchiveTicketReq) => [
  ENDPOINT.MANAGEMENT.ARCHIVE_TICKET.url,
  payload,
];
